import React from "react";
import { Routes, Route, useParams } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { Home, AddManageVideo, AddManageCourse, AddManageQuestionnaire, AddManageResource, LoginHome, AllCourses, NotFound, ViewCourse, AssignCourse, Rti, WebsitePolicy, PrivacyPolicy, TermsAndConditions, CopyrightPolicy, ContactUs, WebInfoManager, LoginPage, AboutUs, Registeration, AdminSettings, AllReports, CreatePlan, ViewPlan } from '../pages'

function WithParams(Component) {
  return function WrappedComponent(props) {
    const params = useParams();
    return <Component {...props} {...params} />;
  };
}
const WithParamsComponent = WithParams(ViewCourse);

function RoutesComponent() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<Registeration />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/rti" element={<Rti />} />
      <Route path="/websitepolicy" element={<WebsitePolicy />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/terms&conditions" element={<TermsAndConditions />} />
      <Route path="/copyrightpolicy" element={<CopyrightPolicy />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/wim" element={<WebInfoManager />} />
      <Route
        path="/home"
        element={
          <PrivateRoute>
            <LoginHome />
          </PrivateRoute>
        }
      />
      <Route
        path="/createcourse"
        element={
          <PrivateRoute>
            <AddManageCourse />
          </PrivateRoute>
        }
      />
      <Route
        path="/addmanagevideo"
        element={
          <PrivateRoute>
            <AddManageVideo />
          </PrivateRoute>
        }
      />
      <Route
        path="/addmanagequestionnaire"
        element={
          <PrivateRoute>
            <AddManageQuestionnaire />
          </PrivateRoute>
        }
      />
      <Route
        path="/addmanageresource"
        element={
          <PrivateRoute>
            <AddManageResource />
          </PrivateRoute>
        }
      />
      <Route
        path="/allcourses"
        element={
          <PrivateRoute>
            <AllCourses />
          </PrivateRoute>
        }
      />
      <Route
        path="/viewcourses/:courseId"
        element={
          <PrivateRoute>
            <WithParamsComponent />
          </PrivateRoute>
        }
      />
      <Route
        path="/assigncourse"
        element={
          <PrivateRoute>
            <AssignCourse />
          </PrivateRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <PrivateRoute>
            <AllReports />
          </PrivateRoute>
        }
      />
      <Route
        path="/adminsettings"
        element={
          <PrivateRoute>
            <AdminSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="/createplan"
        element={
          <PrivateRoute>
            <CreatePlan />
          </PrivateRoute>
        }
      />
      <Route
        path="/viewplan"
        element={
          <PrivateRoute>
            <ViewPlan />
          </PrivateRoute>
        }
      />
      <Route
        path="/*"
        element={<NotFound />}
      />
    </Routes>
  );
}
export default RoutesComponent;
